"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _leadingOffset = _interopRequireDefault(require("../run/leadingOffset"));
/**
 * Get attributed string leading white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} leading white space offset
 */


var leadingOffset = function leadingOffset(attributedString) {
  var runs = attributedString.runs || [];
  return (0, _leadingOffset["default"])(runs[0]);
};

var _default = leadingOffset;
exports["default"] = _default;